<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <page-title :routeProps="routeProps"></page-title>
          <div class="vertical-center-container text-xs-right">
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-container fluid>
        <v-layout>
          <v-flex xs12 sm6 lg3>
            <div class="flex-container-space-between">
              <v-autocomplete
                label="Choose filter"
                :items="filterCols"
                v-model="filterCol"
                prepend-icon="list"
                :clearable="true"
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>
          <div class="text-xs-right grey--text body-2">
            <v-btn
              color="grey"
              flat
              style="text-transform: capitalize"
              @click="drawer = true"
              class="mb-0"
            >
              <!-- <v-icon left>
                                    {{$store.state.global.pages.confirmedTrip.icon}}
              </v-icon>-->
              <span v-if="!showCreated">Billing Period: {{billingPeriod}}</span>
              <span v-else>Showing only newly created RCTIs</span>
            </v-btn>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>

      <v-card-actions></v-card-actions>
      <!-- <v-btn fab dark :color="routeProps.color" class="overlap-fab" @click="addDocketDialog = true">
                    <v-icon dark>add</v-icon>
      </v-btn>-->
    </v-card>
    <!-- <v-navigation-drawer
            persistent
            temporary
            :mini-variant=false
            :clipped=false
            v-model="drawer"
            enable-resize-watcher
            fixed
            app
            right
            >
                <div>
                    <v-list subheader two-line>
                        <v-subheader>Filters and Settings</v-subheader>
                        
                            
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>calendar_today</v-icon>
                                </v-list-tile-action>  
                                <v-autocomplete
                                label="Billing Period" 
                                color="indigo" 
                                :items="billingPeriods"
                                v-model="billingPeriod"
                                >
                                </v-autocomplete>
                            </v-list-tile>
                            
                    </v-list>
                </div>
    </v-navigation-drawer>-->
    <filter-drawer></filter-drawer>
    <docket-add-wrapper v-model="addDocketDialog"></docket-add-wrapper>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import DocketAddWrapper from "@/components/addDocket/wrapper";
import FilterDrawer from "@/components/trips/filterDrawer";
import RouteProps from "@/services/mixins/routeProps";
import BillingPeriods from "@/services/mixins/billingPeriods";

import { addDays } from "date-fns";
import FormatDates from "@/services/mixins/formatDates";
import DateRangeOptions from "@/services/mixins/dateRangeOptions";
import VDateRange from "@/components/ui/vDateRange";
export default {
  mixins: [RouteProps, FormatDates, DateRangeOptions, BillingPeriods],
  data() {
    return {
      snackbarText: "",
      snackbarColor: "blue",
      showSnackbar: false,
      addDocketDialog: false,
      //drawer: false,
      filterCols: [
        {
          value: "status",
          text: "Status"
        },
        {
          value: "project.name",
          text: "Project"
        },
        {
          value: "contractor.name",
          text: "Sub-contractor"
        },
        {
          value: "user.name",
          text: "Entered By"
        },
        {
          value: "abn",
          text: "ABN"
        },
        {
          value: "externalRef",
          text: "Reference"
        },
        {
          value: "notes",
          text: "Notes"
        }
      ],
      dateRangeOptions: {
        startDate: "2019-01-03",
        endDate: "2019-02-02",
        format: "DD/MM/YYYY",
        //maxDate: format(new Date()+1000 * 60 * 60 * 24 * 30, 'YYYY-MM-DD'),
        maxDate: this.makeComputerDate(addDays(new Date(), 30)),
        presets: [
          {
            label: "Today",
            range: [
              this.makeComputerDate(new Date()), //start date. YYYY-MM-DD
              this.makeComputerDate(new Date()) // end date. YYYY-MM-DD
            ]
          },
          {
            label: "Last 15 days",
            range: [
              this.makeComputerDate(addDays(new Date(), -15)), //start date. YYYY-MM-DD
              this.makeComputerDate(new Date()) // end date. YYYY-MM-DD
            ]
          },
          {
            label: "Last 30 days + Next 30 days",
            range: [
              this.makeComputerDate(addDays(new Date(), -30)), //start date. YYYY-MM-DD
              this.makeComputerDate(addDays(new Date(), 30))
            ]
          }
        ]
      },
      dateRangeMenu: false
    };
  },
  components: {
    DocketAddWrapper,
    VDateRange,
    FilterDrawer
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    },
    onDateRangeChange(val) {
      //console.log("date range changed" + val);
    }
  },
  computed: {
    filterCol: Store.getSet({ store: "rctis", prop: "filterCol" }),
    filterBy: Store.getSet({ store: "rctis", prop: "filterBy" }),
    dates: Store.getSet({ store: "rctis", prop: "dates" }),
    billingPeriod: Store.getSet({ store: "shared", prop: "billingPeriod" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    drawer: Store.getSet({ store: "shared", prop: "drawer" }),
    showCreated: Store.getSet({ store: "shared", prop: "showCreated" })
  },
  mounted() {
    this.dates = [
      this.makeComputerDate(addDays(new Date(), -15)), //start date. YYYY-MM-DD
      this.makeComputerDate(new Date()) // end date. YYYY-MM-DD
    ];
  }
};
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
